import { InstantBookSettings, s2n_reserve_quote, s2n_reserve_params, s2n_spots_availability } from "../util/type_defs";

export const add_membership = async (type:string, id:string):Promise<string> => {
    return new Promise<string>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/instantBook_memberships",
            data: JSON.stringify({
                type: type,
                id: id
            }),
            contentType: "application/json",
            dataType: "html",
            success: (data) => { resolve(data); },
            error: (xhr, textStatus, errorThrown) => {
                let errorMessage = xhr.responseText || textStatus;
                reject(new Error(errorMessage));
            }
        });
    });
};

export const get_customer_memberships = async ():Promise<string> => {
    return new Promise<string>((resolve,reject) => {
        $.ajax({
            type: "get",
            url: "/instantBook_memberships",
            dataType: "html",
            success: (data) => { resolve(data); },
            error: (xhr, textStatus, errorThrown) => {
                let errorMessage = xhr.responseText || textStatus;
                reject(new Error(errorMessage));
            }
        })
    });
};

export const get_spots_availability = (settings: InstantBookSettings): Promise<s2n_spots_availability> => {
    return new Promise<s2n_spots_availability>((resolve, reject) => {
        $.ajax({
            type: "post",
            url: "/instantBook_availabilitySearch",
            data: JSON.stringify(settings),
            contentType: "application/json",
            dataType: "json",
            success: (data) => {
                resolve(data);
            },
            error: (xhr, textStatus, errorThrown) => {
                let errorMessage = xhr.responseText || textStatus;
                reject(new Error(errorMessage));
            }
        });
    });
};

export const get_reservation_details = (reservationId:number):Promise<string> => {
    return new Promise<string>((resolve,reject) => {
        $.ajax({
            type: "get",
            url: `/reservation/${reservationId}`,
            dataType: "html",
            success: (data) => {resolve(data);},
            error: (xhr, textStatus, errorThrown) => {
                let errorMessage = xhr.responseText || textStatus;
                reject(new Error(errorMessage));
            }
        })
    })
}

export const make_reservation = (spotId:number, settings:InstantBookSettings): Promise<{reservationId:number|string,html:string}> => {
    const params:s2n_reserve_params = {
        guests:settings.guests,
        vehicleProfile: {
            length:settings.vehicleLength,
            slideouts:settings.slideouts,
            type:settings.vehicleType
        },
        bookingInformation: {
            spotId:spotId,
            parkId:settings.parkId,
            checkIn:settings.dates[0],
            checkOut:settings.dates[1]
        }
    };
    return new Promise<{reservationId:number,html:string}>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/instantBook_reserve",
            data: JSON.stringify(params),
            contentType: "application/json",
            dataType: "json",
            success: (data) => {
                resolve(data);
            },
            error: (xhr, textStatus, errorThrown) => {
                // Use the responseText or construct a more specific message as needed
                let errorMessage = xhr.responseText || textStatus;
                reject(new Error(errorMessage));
            }
        });
    });
};

export const get_reserve_quote = (spotId:number, settings:InstantBookSettings): Promise<string> => {
    const params:s2n_reserve_params = {
        guests:settings.guests,
        vehicleProfile: {
            length:settings.vehicleLength,
            slideouts:settings.slideouts,
            type:settings.vehicleType
        },
        bookingInformation: {
            spotId:spotId,
            parkId:settings.parkId,
            checkIn:settings.dates[0],
            checkOut:settings.dates[1]
        }
    }

    return new Promise<string>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/instantBook_quote",
            data: JSON.stringify(params),
            contentType: "application/json",
            dataType: "html",
            success: (data) => {
                resolve(data);
            },
            error: (xhr, textStatus, errorThrown) => {
                // Use the responseText or construct a more specific message as needed
                let errorMessage = xhr.responseText || textStatus;
                reject(new Error(errorMessage));
            }
        });
    });
};


export function get_customer_token():Promise<string> {
    return new Promise<string>((resolve,reject) => {
        $.ajax({
            type: "get",
            url: "/instantBook_token",
            success: (data) => {
                resolve(data);
            },
            error: (xhr, textStatus, errorThrown) => {
                let errorMessage = xhr.responseText || textStatus;
                reject(new Error(errorMessage));
            }
        });
    });
};

export const update_s2n_client = (form:JQuery<HTMLElement>):Promise<{token:string,html:string}> => {
    return new Promise<{token:string,html:string}>((resolve,reject) => {
        $.ajax({
            type: "post",
            url: "/instantBook_clientInfo",
            data: form.serialize(),
            dataType: "json",
            success: (data) => {resolve(data);},
            error: (xhr, textStatus, errorThrown) => {
                let errorMessage = xhr.responseText || textStatus;
                reject(new Error(errorMessage));
            }
        })
    });
};